import React from 'react';
import { Box, Container, Typography, Grid, Stack } from '@mui/material';
import {
  TravelExploreOutlined, ForumOutlined, PublishOutlined, AssessmentOutlined,
} from '@mui/icons-material';
import { C, Section, SectionLabel } from './theme';

const steps = [
  {
    icon: <TravelExploreOutlined sx={{ fontSize: 26 }} />,
    title: '1. Research & Prospecting',
    desc: 'We find real, niche-relevant websites with genuine authority and traffic that match your industry.',
  },
  {
    icon: <ForumOutlined sx={{ fontSize: 26 }} />,
    title: '2. Manual Outreach',
    desc: 'Our team personally contacts site owners and editors — no bulk emails, no automated pitches.',
  },
  {
    icon: <PublishOutlined sx={{ fontSize: 26 }} />,
    title: '3. Content & Placement',
    desc: 'Your link is placed naturally within relevant content, or via a fresh guest post written for the site.',
  },
  {
    icon: <AssessmentOutlined sx={{ fontSize: 26 }} />,
    title: '4. Report & Review',
    desc: 'You receive a full report with live URLs and authority metrics — visible anytime in your account.',
  },
];

const VpsProcess = () => (
  <Section id="process" sx={{ background: '#FFFFFF', borderBottom: `1px solid ${C.border}` }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 7 }}>
        <SectionLabel>How It Works</SectionLabel>
        <Typography variant="h2" sx={{
          fontWeight: 800, fontSize: { xs: '1.85rem', md: '2.5rem' },
          color: C.textPrimary, letterSpacing: '-0.03em', mb: 1.5,
        }}>
          From order to live backlink, fully transparent
        </Typography>
        <Typography sx={{ color: C.textSecondary, fontSize: '1rem', maxWidth: 620, mx: 'auto', lineHeight: 1.6 }}>
          A simple four-step process — no black boxes, no guesswork about where your links actually go.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {steps.map((s) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={s.title}>
            <Stack spacing={2} sx={{
              p: 3, height: '100%', borderRadius: '16px',
              border: `1px solid ${C.border}`, background: C.bgSection,
            }}>
              <Box sx={{
                width: 52, height: 52, borderRadius: '14px', background: C.gradient,
                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF',
              }}>
                {s.icon}
              </Box>
              <Typography sx={{ fontWeight: 800, fontSize: '1.02rem', color: C.textPrimary }}>
                {s.title}
              </Typography>
              <Typography sx={{ color: C.textSecondary, fontSize: '0.88rem', lineHeight: 1.6 }}>
                {s.desc}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Section>
);

export default VpsProcess;
